import { get, sync } from 'vuex-pathify';
import { debounce } from 'lodash';
export default {
  computed: {
    settingsValues: get('admin/settings'),
    currentOffers: sync('featuresData/currentOffers'),
    filterPayload: sync('map/filterPayload'),
    lngOffers: get('featuresData/lngOffers'),
    currentLng() {
      return this.$i18n.locale;
    },
    currentLngAllOffers() {
      return this.lngOffers[this.currentLng]?.features || [];
    },
    offersAttributesNames() {
      const { value: offersSettingValue } = this.settingsValues['OFFERT_SETTING'];
      const { value: filterSettingValue } = this.settingsValues['FILTER_SETTING'];
      return {
        name: offersSettingValue.name_attribute,
        voivodeship: filterSettingValue?.attributes.voivodeship_attribute,
        district: filterSettingValue?.attributes.district_attribute,
        commune: filterSettingValue?.attributes.commune_attribute,
        area: offersSettingValue.area_attribute,
        distanceFromHighway: filterSettingValue?.attributes.highway_distance_attribute,
        distanceFromRailway: filterSettingValue?.attributes.railway_distance_attribute,
        buildingHeight: filterSettingValue?.attributes.building_height_attribute,
      };
    },
    layers: get('featuresData/layers'),
  },
  methods: {
    setCurrentOffers(filter = this.filterPayload) {
      filter = Object.keys(JSON.parse(JSON.stringify(filter))).reduce((total, current) => {
        if (filter[current] !== null && filter[current] !== undefined) total[current] = filter[current];
        return total;
      }, {});
      const {
        category,
        voivodeship,
        district,
        commune,
        areaFrom,
        areaTo,
        distanceFromHighway: { min: dFHmin, max: dFHmax } = {},
        distanceFromRailway: { min: dFRmin, max: dFRmax } = {},
        buildingHeight: { min: bHmin, max: bHmax } = {},
      } = filter;
      this.currentOffers = JSON.parse(JSON.stringify(this.currentLngAllOffers)).filter(offer => {
        return (
          (!category?.length || category.includes(offer.layerId)) &&
          (!voivodeship?.length || voivodeship.includes(offer.properties[this.offersAttributesNames.voivodeship])) &&
          (!district?.length || district.includes(offer.properties[this.offersAttributesNames.district])) &&
          (!commune?.length || commune.includes(offer.properties[this.offersAttributesNames.commune])) &&
          ((!areaFrom && areaFrom !== 0) || areaFrom <= offer.properties[this.offersAttributesNames.area]) &&
          ((!areaTo && areaTo !== 0) || areaTo >= offer.properties[this.offersAttributesNames.area]) &&
          ((!dFHmin && dFHmin !== 0) || offer.properties[this.offersAttributesNames.distanceFromHighway] >= dFHmin) &&
          ((!dFHmax && dFHmax !== 0) || offer.properties[this.offersAttributesNames.distanceFromHighway] <= dFHmax) &&
          ((!dFRmin && dFRmin !== 0) || offer.properties[this.offersAttributesNames.distanceFromRailway] >= dFRmin) &&
          ((!dFRmax && dFRmax !== 0) || offer.properties[this.offersAttributesNames.distanceFromRailway] <= dFRmax) &&
          ((!bHmin && bHmin !== 0) || offer.properties[this.offersAttributesNames.buildingHeight] >= bHmin) &&
          ((!bHmax && bHmax !== 0) || offer.properties[this.offersAttributesNames.buildingHeight] <= bHmax)
        );
      });
      this.$root.$emit('updateOffersClusterLayerFeatures');
    },
  },
  watch: {
    filterPayload: {
      handler(nV) {
        this.setCurrentOffers(nV);
      },
      deep: true,
    },
  },
  created() {
    this.setCurrentOffers = debounce(this.setCurrentOffers, 1000);
  },
};
